import React, { useState, useContext, useMemo, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import CreateEvent from "./CreateEvent";
import UserService from "services/UserService";
import axios from "axios";
import { getEvents } from "services/ConfigServices";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";
import { eventpagetext } from "variables/event";
import { statusData } from "variables/lists/event";
import moment from "moment";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

export default function useEventsTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const eventsadmin = permis.includes("events_admin");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const [totalRows, setTotalRows] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const url = getEvents(chartIdGroup);
  const [results, setResults] = useState({});
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedEvents, setSelectedEvents] = useState([]);

  const refreshTable = () => {
    setRefresh(!refresh);
  }

  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === chartIdGroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      //setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          url,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        setResults(response.data);
        setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = chartIdGroup;
      fetchData();
    }
  }, [chartIdGroup, refresh]);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const filteredItems = _.get(results, `events`, []).filter(
    (item) =>
      (item.parameters.category && item.parameters.category.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.title && item.parameters.title.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.description && item.parameters.description.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.idgroup && groupInfoListById["" + item.idgroup] && groupInfoListById["" + item.parameters.groups[0]].toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.status && statusData.find((x) => x.id == item.parameters.status) && statusData.find((x) => x.id == item.parameters.status).name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.datebegin && moment(item.parameters.datebegin).isValid() && moment(item.parameters.datebegin).format("DD/MM/YYYY HH:mm").includes(filterText)) ||
      (item.parameters.dateend && moment(item.parameters.dateend).isValid() && moment(item.parameters.dateend).format("DD/MM/YYYY HH:mm").includes(filterText))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = selectedEvents.map((item) => {
      let eventtoexport = {};
      eventtoexport[eventpagetext.category] = item.parameters.category;
      eventtoexport[eventpagetext.title] = item.parameters.title;
      eventtoexport[eventpagetext.description] = item.parameters.description;
      eventtoexport[eventpagetext.status] = statusData.find((x) => x.id == item.parameters.status)?.name;
      eventtoexport[eventpagetext.datebegin] = (item.parameters.datebegin && moment(item.parameters.datebegin).isValid()) ? moment(item.parameters.datebegin).format("DD/MM/YYYY HH:mm") : "";
      eventtoexport[eventpagetext.dateend] = (item.parameters.dateend && moment(item.parameters.dateend).isValid()) ? moment(item.parameters.dateend).format("DD/MM/YYYY HH:mm") : "";
      eventtoexport[eventpagetext.author] = item.parameters.author;
      eventtoexport[eventpagetext.groups] = (item.idgroup && groupInfoListById["" + item.idgroup]) ? groupInfoListById["" + item.idgroup] : "";
      return eventtoexport;
    });

    return (
      <>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {eventsadmin && (
          <UploadButton type="button" onClick={handleClear}>
            <CreateEvent refetch={refreshTable} onClick={handleClear} />
          </UploadButton>
        )}
        <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!selectedEvents || selectedEvents.length < 1} />
        </UploadButton>
      </>
    );
  }, [filterText, resetPaginationToggle, selectedEvents]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
    },
    refreshTable,
    setSelectedEvents,
    setLoading
  };
}
